import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Injectable()
export class ApplicationAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'application';

  public GetAppId(code: string) {
    const request = 'getApplicationId';
    const url = this._apiService
      .buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request, { code: code })
      .replace('/tap', '');

    return this._apiService.getRaw(url);
  }
}
